import Axios from '@/axios'


export const menu = function (data={}) {
  return Axios({
    url: '/adminapi/v1/menu',
    method: 'post',
    data,
  })
}
